import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { getSupportResolutionBreakdown } from '../../services/ticketService';
import SupportResolutionBreakdownChart from '../../components/dashboards/SupportResolutionBreakdownChart';
import DashboardPeriodFilter from '../../components/dashboards/DashboardPeriodFilter';
import {
  buildPeriodApiParams,
  DEFAULT_PERIOD_PRESET,
} from '../../services/dashboardPeriodService';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 2rem;
  background-color: var(--color-bg-secondary);
  min-height: 100vh;
  overflow-x: hidden;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const PageTitle = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 650;
  letter-spacing: -0.02em;
  line-height: 1.2;
  color: var(--color-text-primary);
`;

const FiltersRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: flex-end;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const SupportResolutionBreakdownPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [periodPreset, setPeriodPreset] = useState(DEFAULT_PERIOD_PRESET);

  const periodParams = useMemo(
    () => buildPeriodApiParams(periodPreset),
    [periodPreset]
  );

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const res = await getSupportResolutionBreakdown({
        from: periodParams.from,
        to: periodParams.to,
      });
      setData(Array.isArray(res) ? res : []);
    } catch (err) {
      console.error('Error fetching support resolution breakdown:', err);
      setData([]);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [periodParams.from, periodParams.to]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <PageContainer>
      <PageTitle>Dashboards • Motivos de resolução (Suporte/Bug)</PageTitle>
      <FiltersRow>
        <DashboardPeriodFilter
          value={periodPreset}
          onChange={setPeriodPreset}
          disabled={loading}
          fieldId="dashboard-support-resolution-period"
        />
      </FiltersRow>
      <SupportResolutionBreakdownChart
        data={data}
        loading={loading}
        error={error}
        onRetry={fetchData}
        periodLabel={periodParams.label}
      />
    </PageContainer>
  );
};

export default SupportResolutionBreakdownPage;
